import {
  AuthRequest,
  AuthSuccess,
  AuthError,
  AuthLogout
} from "../actions/auth";

import authApi from "@/services/api/auth";
import userApi from "@/services/api/user";

const state = {
  accessToken: localStorage.getItem("user-token") || null,
  status: "",
  user: null,
  security: []
};

const getters = {
  isAuthenticated: state => !!state.accessToken,
  authStatus: state => state.status
};

const actions = {
  [AuthRequest]: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      commit(AuthRequest); // set the state.status to loading
      authApi
        .login(user, { errorHandle: false }) // make the api call
        .then(resp => {
          localStorage.setItem("user-token", resp.access_token);
          commit(AuthSuccess, resp);
          resolve();
        })
        .catch(err => {
          commit(AuthError); // set the state.status to error
          reject(err);
        });
    });
  },
  [AuthLogout]: ({ commit }) => {
    return new Promise(resolve => {
      localStorage.removeItem("user-token");
      commit(AuthLogout);
      resolve();
    });
  }
};

const mutations = {
  [AuthRequest]: state => {
    state.status = "loading";
  },
  [AuthSuccess]: (state, resp) => {
    state.status = "success";
    state.accessToken = resp.access_token;
    state.user = resp.user;
    state.security = resp.security;
  },
  [AuthError]: state => {
    state.status = "error";
  },
  [AuthLogout]: state => {
    state.status = "";
    state.accessToken = null;
    state.user = null;
    state.security = [];
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
